<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "rumorManage"
  }
</script>

<style scoped>
</style>
